<template>
  <v-btn
    color="success"
    href="https://app.sunnycloud.se/Signup"
    :x-large="xLarge"
    elevation="0"
  >
    {{ text }}
  </v-btn>
</template>

<script>
export default {
  components: {
  },
  props: {
    text: {
      type: String,
      required: false,
      default: 'Skapa konto',
    },
    xLarge: {
      type: Boolean,
      required: false,
    },
  },
}
</script>
